module.exports = __webpack_public_path__ + "static/u3-c28f3c833fd8dbb72a8769ca4689efd7.png";